import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';
import { PhConfigLoaderService } from '../ph-config-loader/ph-config-loader.service';

@Injectable({
  providedIn: 'root'
})
export class Document360Service {
  private readonly doc360WidgetInitializationCallback: () => void;

  constructor(
    @Inject(DOCUMENT) private document,
    private readonly config: PhConfigLoaderService,
  ) {
    this.doc360WidgetInitializationCallback =
      this.handleDoc360WidgetPostInitialization.bind(this);

    this.load(this.config.getConfig('DOCUMENT_360_API_KEY'));
  }

  load(apiKey: string) {
    (function (w, d, s, o, f, js, fjs) {
      w['JS-Widget'] = o;
      w[o] =
        w[o] ||
        function () {
          (w[o].q = w[o].q || []).push(arguments);
        };
      (js = d.createElement(s)), (fjs = d.getElementsByTagName(s)[0]);
      js.id = o;
      js.src = f;
      js.async = 1;
      fjs.parentNode.insertBefore(js, fjs);
    })(
      window,
      this.document,
      'script',
      'mw',
      'https://cdn.document360.io/static/js/widget.js'
    );

    (window as any).mw('init', {
      apiKey: apiKey,
      callback: this.doc360WidgetInitializationCallback,
    });
  }

  openDoc360Widget(): void {
    try {
      this.document
        .getElementById('document360-widget-iframe')
        ?.contentDocument?.getElementById('doc360-button')
        ?.click();
    } catch {
      console.error(
        $localize`Failed to open Document360 widget. Ensure the widget is loaded correctly.`
      );
    }
  }

  private handleDoc360WidgetPostInitialization(): void {
    const customDoc360StylesheetElement = this.document.createElement('style');
    customDoc360StylesheetElement.textContent = `
      #document360-widget-iframe {
        display: none !important;
      }
    `;
    this.document.head.appendChild(customDoc360StylesheetElement);
  }
}
